import { cn } from "@/lib/utils"

export interface ValidationRule {
  required?: boolean
  minLength?: number
  maxLength?: number
  pattern?: RegExp
  min?: number
  max?: number
  custom?: (value: any) => string | null
}

export interface ValidationResult {
  isValid: boolean
  errors: string[]
  hasErrors: boolean
}

export const validateField = (
  value: any,
  rules: ValidationRule,
  label?: string
): ValidationResult => {
  const errors: string[] = []

  // Required validation
  if (rules.required && (!value || (typeof value === 'string' && !value.trim()))) {
    errors.push(`${label || 'Dieses Feld'} ist erforderlich`)
  }

  // Skip other validations if field is empty and not required
  if (!value || (typeof value === 'string' && !value.trim())) {
    return {
      isValid: errors.length === 0,
      errors,
      hasErrors: errors.length > 0
    }
  }

  // String validations
  if (typeof value === 'string') {
    if (rules.minLength && value.length < rules.minLength) {
      errors.push(`Mindestens ${rules.minLength} Zeichen erforderlich`)
    }
    if (rules.maxLength && value.length > rules.maxLength) {
      errors.push(`Maximal ${rules.maxLength} Zeichen erlaubt`)
    }
    if (rules.pattern && !rules.pattern.test(value)) {
      errors.push(`Ungültiges Format`)
    }
  }

  // Number validations
  if (typeof value === 'number' || !isNaN(Number(value))) {
    const numValue = Number(value)
    if (rules.min !== undefined && numValue < rules.min) {
      errors.push(`Mindestens ${rules.min} erforderlich`)
    }
    if (rules.max !== undefined && numValue > rules.max) {
      errors.push(`Maximal ${rules.max} erlaubt`)
    }
  }

  // Custom validation
  if (rules.custom) {
    const customError = rules.custom(value)
    if (customError) {
      errors.push(customError)
    }
  }

  return {
    isValid: errors.length === 0,
    errors,
    hasErrors: errors.length > 0
  }
}

export const getInputErrorStyles = (hasErrors: boolean, isValid: boolean = false) => {
  return cn(
    hasErrors && "border-destructive focus-visible:ring-destructive",
    isValid && "border-green-500 focus-visible:ring-green-500"
  )
}

// Email validation pattern
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Phone validation pattern (German format)
export const PHONE_PATTERN = /^(\+49|0)[1-9]\d{7,11}$/

// Postal code validation pattern (German format)
export const POSTAL_CODE_PATTERN = /^\d{5}$/